(() => {
  if (window.matchingPullsTracking) return;

  const publish = (name, data) => {
    document.dispatchEvent(
      new CustomEvent('hesita:matching-pulls-publish', {
        detail: { name, data },
      })
    );
  };

  window.matchingPullsTracking = { publish };

  const observeOffer = (offer) => {
    if (offer.dataset.matchingPullsTrackingReady === 'true') return;
    offer.dataset.matchingPullsTrackingReady = 'true';

    const impressionObserver = new IntersectionObserver(
      (entries, observer) => {
        const entry = entries[0];
        if (!entry?.isIntersecting || !offer.querySelector('.card-wrapper')) return;

        publish('hesita_matching_pulls:impression', {
          offer_name: 'Matching pulls',
          offer_version: 'native_v1',
          parent_product_id: offer.dataset.parentProductId,
          parent_product_handle: offer.dataset.parentProductHandle,
          currency: offer.dataset.currency,
          recommended_product_ids: Array.from(
            offer.querySelectorAll('[data-matching-pulls-product-id]'),
            (element) => element.dataset.matchingPullsProductId
          ),
        });
        observer.disconnect();
      },
      { threshold: 0.25 }
    );

    impressionObserver.observe(offer);
  };

  document.querySelectorAll('product-recommendations[data-matching-pulls]').forEach(observeOffer);
})();
